const R = require("ramda");

const FONT_NAMES = {
  GEORGIA: "gerogia",
  PROXIMA_NOVA: "proxima_nova",
  LATO: "lato",
  MERRIWEATHER: "merriweather",
  ROBOTO: "roboto",
  OPEN_SANS: "open_sans"
};

const getFontCssName = font =>
  R.propOr(
    font,
    font
  )({
    [FONT_NAMES.OPEN_SANS]: `'Open Sans'`,
    [FONT_NAMES.PROXIMA_NOVA]: "proxima-nova"
  });

const getFontCss = font =>
  R.prop(font)({
    [FONT_NAMES.LATO]: `@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');`,
    [FONT_NAMES.MERRIWEATHER]: `@import url('https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap');`,
    [FONT_NAMES.ROBOTO]: `@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');`,
    [FONT_NAMES.OPEN_SANS]: `@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');`
  });

const resolveFontCss = ({ fonts }) => {
  let css = "";

  for (const font of fonts) {
    const fontCss = getFontCss(font);

    if (fontCss) {
      css = `${css}
${fontCss}
`;
    }
  }

  return css && css.length ? css : null;
};

export { FONT_NAMES, getFontCssName, resolveFontCss };
